import React, { useState } from 'react';
import { useNavigate} from 'react-router-dom';
import { Alert, Heading, Stack, Box, SegmentGroup, HStack, Text, Textarea, Field,Flex, Spacer, Input, Select, createListCollection, Portal, Button} from '@chakra-ui/react';
import axios from 'axios';
import { LuTestTubes, LuFileSpreadsheet, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"
import PageTitle from 'components/ui/PageTitle';
import PageContent from 'components/ui/PageContent';
import SampleSelect from 'components/ui/SampleSelect';

function SamplesOverviewPage() {

  return (
    <PageContent>
      <PageTitle icon={LuTestTubes} title="Samples and Projects" />

      

      <Heading>Sample Selection</Heading>
      <Flex>
        <SampleSelect noCheckboxes={true} />
      </Flex>


    </PageContent>

  );
}

export default SamplesOverviewPage;
